import { api, admin, tokenName } from '../config.js';

export default class Client {
    token = '';
    fetchMethods = {
        get: 'GET',
        post: 'POST',
        patch: 'PATCH',
        delete: 'DELETE'
    }

    loadToken = () => {
            this.token = localStorage.getItem(tokenName);
    }
    
    fetchOptions(method, body = null, withToken = false, image = false) {
        let modifiedBody = JSON.stringify(body);
        const headers = new Headers();
        if(withToken) {
            this.loadToken();
            headers.append("Authorization", `Bearer ${this.token}`);
            headers.append("Access-Control-Request-Method", `${method}`);
            headers.append("Access-Control-Request-Headers", 'origin, x-requested-with');
            headers.append("Origin", admin);
        }
        if(image) {
            modifiedBody = body;
        } else {
            headers.append("Accept", "Bearer application/json");
            headers.append("Content-Type", "application/json");
        }

        if(body) {
            return {
                method,
                headers,
                body: modifiedBody
            };
        }

        return {
            method,
            headers
        }   
    }

    // Accounts

    async getAccountById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const account = await fetch(`${api}/admin/user/${id}`, requestOptions);
        const res = await account.json();
        return res;
    }

    async getAccountByPasswordToken(passwordToken) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const account = await fetch(`${api}/account/activate/${passwordToken}`, requestOptions);
        const res = await account.json();
        return res;
    }

    async getAccount() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const account = await fetch(`${api}/admin/user/account`, requestOptions);
        const res = await account.json();

        return res;
    }

    async getAccounts() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const account = await fetch(`${api}/admin/users`, requestOptions);
        const res = await account.json();
        return res;
    }

    async searchAccounts(params) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const search = await fetch(`${api}/admin/users/search${params}`, requestOptions);
        const res = await search.json();
        return res;
    }

    async createAccount(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const account = await fetch(`${api}/admin/user/accounts`, requestOptions);
        const res = await account.json();
        return res;
    }

    async activateAdminCreatedAccount(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data);
        const categories = await fetch(`${api}/account/activate`, requestOptions);
        const res = await categories.json();
        return res;
    }

    async updateAccount(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const account = await fetch(`${api}/admin/users`, requestOptions);
        const res = await account.json();

        return res;
    }

    async updateAccountPassword(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const updateAccountPassword = await fetch(`${api}/user/update-password`, requestOptions);
        const res = await updateAccountPassword.json();
        return res;
    }

    async deleteAccount() {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, '', true);
        const deleteAccountRes = await fetch(`${api}/user/delete-account`, requestOptions);
        const res = await deleteAccountRes.json();
        return res;
    }

    // Backorders

    async getBackorders(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const backorders = await fetch(`${api}/admin/backorders${query}`, requestOptions);
        const res = await backorders.json();
        return res;
    }

    // Categories

    async getAllCategories(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const categories = await fetch(`${api}/admin/categories${query}`, requestOptions);
        const res = await categories.json();
        return res;
    }

    async getCategoryById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const categories = await fetch(`${api}/admin/categories/${id}`, requestOptions);
        const res = await categories.json();
        return res;
    }

    async getCategoriesByType(type) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get);
        const categories = await fetch(`${api}/categories/type/${type}`, requestOptions);
        const res = await categories.json();
        return res;
    }

    async createCategory(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const categories = await fetch(`${api}/admin/categories`, requestOptions);
        const res = await categories.json();
        return res;
    }

    async addCategoryImage(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true, true);
        const categories = await fetch(`${api}/admin/categories/images/thumbnail`, requestOptions);
        const res = await categories.json();
        return res;
    }

    async updateCategory(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const categories = await fetch(`${api}/admin/categories`, requestOptions);
        const res = await categories.json();
        return res;
    }

    async deleteCategoryThumbnail(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const categories = await fetch(`${api}/admin/categories/images/thumbnail/delete`, requestOptions);
        const res = await categories.json();
        return res;
    }

    async deleteCategory(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, data, true);
        const categories = await fetch(`${api}/admin/categories`, requestOptions);
        const res = await categories.json();
        return res;
    }

    // Category Types

    async getAllCategoryTypes(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const result = await fetch(`${api}/admin/category-types${query}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async getCategoryTypeById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const result = await fetch(`${api}/admin/category-types/${id}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async createCategoryType(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const result = await fetch(`${api}/admin/category-types`, requestOptions);
        const res = await result.json();
        return res;
    }

    async updateCategoryType(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.put, data, true);
        const result = await fetch(`${api}/admin/category-types/${id}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async deleteCategoryType(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const result = await fetch(`${api}/admin/category-types/${id}`, requestOptions);
        const res = await result.json();
        return res;
    }

    // Content Management System

    async updateCMS(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const cms = await fetch(`${api}/admin/cms`, requestOptions);
        const res = await cms.json();
        return res;
    }

    // Company

    async getCompanies(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const companies = await fetch(`${api}/admin/companies${query}`, requestOptions);
        const res = await companies.json();
        return res;
    }

    async getCompany() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const companies = await fetch(`${api}/admin/company`, requestOptions);
        const res = await companies.json();
        return res;
    }

    async getCompanyById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const company = await fetch(`${api}/admin/companies/${id}`, requestOptions);
        const res = await company.json();
        return res;
    }

    async createContributorCompany(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const company = await fetch(`${api}/admin/company`, requestOptions);
        const res = await company.json();
        return res;
    }

    async addCompanyLogo(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const companyLogo = await fetch(`${api}/admin/companies/logo`, requestOptions);
        const res = await companyLogo.json();
        return res;
    }

    async updateCompany(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const companies = await fetch(`${api}/admin/companies`, requestOptions);
        const res = await companies.json();
        return res;
    }

    async deleteCompany(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, data, true);
        const company = await fetch(`${api}/admin/companies`, requestOptions);
        const res = await company.json();
        return res;
    }

    async deleteCompanyLogo(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, data, true);
        const company = await fetch(`${api}/admin/companies/logo`, requestOptions);
        const res = await company.json();
        return res;
    }

    // Configuration

    // OLD
    async getOldConfiguration() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const configuration = await fetch(`${api}/admin/configuration`, requestOptions);
        const res = await configuration.json();
        return res;
    }

    // Current

    async getConfigurations() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const configuration = await fetch(`${api}/admin/configurations`, requestOptions);
        const res = await configuration.json();
        return res;
    }

    async getConfigurationById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const configuration = await fetch(`${api}/admin/configurations/${id}`, requestOptions);
        const res = await configuration.json();
        return res;
    }

    async getConfigurationByKey(key) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const configuration = await fetch(`${api}/admin/configurations/key/${key}`, requestOptions);
        const res = await configuration.json();
        return res;
    }

    async getConfigurationsByModule(module) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const configuration = await fetch(`${api}/admin/configurations/module/${module}`, requestOptions);
        const res = await configuration.json();
        return res;
    }

    async addConfigurationImage(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const configurationImage = await fetch(`${api}/admin/configurations/image`, requestOptions);
        const res = await configurationImage.json();
        return res;
    }

    async updateConfigurationById(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const updateConfiguration = await fetch(`${api}/admin/configurations/${id}`, requestOptions);
        const res = await updateConfiguration.json();
        return res;
    }

    async updateConfigurationByKey(key, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const updateConfiguration = await fetch(`${api}/admin/configurations/key/${key}`, requestOptions);
        const res = await updateConfiguration.json();
        return res;
    }

    async setConfigurationImageToActive(configurationEntryId, imageId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, '', true);
        const setConfigurationImageToActive = await fetch(`${api}/admin/configurations/${configurationEntryId}/images/${imageId}/activate`, requestOptions);
        const res = await setConfigurationImageToActive.json();
        return res;
    }

    async deleteConfigurationEntryImage(configId, imageId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const deleteConfigurationEntryImage = await fetch(`${api}/admin/configurations/${configId}/images/${imageId}`, requestOptions);
        const res = await deleteConfigurationEntryImage.json();
        return res;
    }

    // Encryption
    
    async getEncryptionSecret() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const encryptionSecret = await fetch(`${api}/admin/encryption/public-key`, requestOptions);
        const res = await encryptionSecret.json();
        return res;
    }

    // Encrypted Messaging

    async saveEncryptionKeyPair(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const response = await fetch(`${api}/encryption/key`, requestOptions);
        const res = await response.json();
        return res;
    }

    async getEncryptionKeyPair() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const response = await fetch(`${api}/encryption/key`, requestOptions);
        const res = await response.json();
        return res;
    }

    async getPublicKeyForUser(userId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const response = await fetch(`${api}/encryption/key/public/${userId}`, requestOptions);
        const res = await response.json();
        return res;
    }

    async sendEncryptedMessage(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const response = await fetch(`${api}/encryption/message`, requestOptions);
        const res = await response.json();
        return res;
    }

    async getEncryptedMessages() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const response = await fetch(`${api}/encryption/messages`, requestOptions);
        const res = await response.json();
        return res;
    }

    async getConversationWithUser(userId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const response = await fetch(`${api}/encryption/messages/conversation/${userId}`, requestOptions);
        const res = await response.json();
        return res;
    }

    // Fulfillments

    async getAllFulfillments(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/fulfillments${query}`, requestOptions);
        return res.json();
    }

    async getFulfillmentsForOrder(orderId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/orders/${orderId}/fulfillments`, requestOptions);
        return res.json();
    }

    async getFulfillmentById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/fulfillments/${id}`, requestOptions);
        return res.json();
    }

    async getReadyToFulfill() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/fulfillments/ready`, requestOptions);
        return res.json();
    }

    async createFulfillment(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const res = await fetch(`${api}/admin/fulfillments`, requestOptions);
        return res.json();
    }

    async createBatchFulfillments(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const res = await fetch(`${api}/admin/fulfillments/batch`, requestOptions);
        return res.json();
    }

    async updateFulfillment(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const res = await fetch(`${api}/admin/fulfillments/${id}`, requestOptions);
        return res.json();
    }

    async deleteFulfillmentById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const res = await fetch(`${api}/admin/fulfillments/${id}`, requestOptions);
        return res.json();
    }

    // Fulfillment Items

    async createFulfillmentItem(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const res = await fetch(`${api}/admin/fulfillments/items`, requestOptions);
        return res.json();
    }

    async createFulfillmentsFromOrders(orderIds) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, { orderIds }, true);
        const res = await fetch(`${api}/admin/fulfillments/batch`, requestOptions);
        return res.json();
    }

    async updateFulfillmentItem(itemId, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const res = await fetch(`${api}/admin/fulfillments/items/${itemId}`, requestOptions);
        return res.json();
    }

    async deleteFulfillmentItem(itemId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const res = await fetch(`${api}/admin/fulfillments/items/${itemId}`, requestOptions);
        return res.json();
    }

    // Giveaway

    async getGiveawaySignUp(amount = 1) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const giveaway = await fetch(`${api}/admin/giveaway/signup/today/${amount}`, requestOptions);
        const res = await giveaway.json();
        return res;
    }

    async getGiveaways() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const giveaways = await fetch(`${api}/admin/giveaways`, requestOptions);
        const res = await giveaways.json();
        return res;
    }

    async getGiveawayById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const giveaway = await fetch(`${api}/admin/giveaways/${id}`, requestOptions);
        const res = await giveaway.json();
        return res;
    }

    async getRandomUsersForGiveaway({ start, end, amount = 1 }) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(
            `${api}/admin/giveaways/users?start=${start}&end=${end}&amount=${amount}`,
            requestOptions
        );
        return await res.json();
    }

    async getRandomOrdersForGiveaway({ start, end, amount = 1 }) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(
            `${api}/admin/giveaways/orders?start=${start}&end=${end}&amount=${amount}`,
            requestOptions
        );
        return await res.json();
    }

    async createGiveaway(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const giveaway = await fetch(`${api}/admin/giveaways`, requestOptions);
        const res = await giveaway.json();
        return res;
    }

    async updateGiveaway(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const giveaway = await fetch(`${api}/admin/giveaways`, requestOptions);
        const res = await giveaway.json();
        return res;
    }

    async deleteGiveaway(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, data, true);
        const giveaway = await fetch(`${api}/admin/giveaways`, requestOptions);
        const res = await giveaway.json();
        return res;
    }

    // GR Server

    async getGRServerHealth() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const health = await fetch(`${api}/admin/gr-server`, requestOptions);
        
        if(health?.status === 500) {
            return { status: 500 }
        }
        
        const res = await health.json();
        return res;
    }

    async outletStatus() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const outletStatus = await fetch(`${api}/admin/gr-server/outlet-status`, requestOptions);
        const res = await outletStatus.json();
        return res;
    }

    async cyclePowerOnOff(time = 10000) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const cyclePowerOnOff = await fetch(`${api}/admin/gr-server/cycle-outlet/on-off?time=${time}`, requestOptions);
        const res = await cyclePowerOnOff.json();
        return res;
    }

    async getGRServerLogs(query) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const logs = await fetch(`${api}/admin/gr-server/logs${query}`, requestOptions);
        const res = await logs.json();
        return res;
    }

    async deleteGRServerLogById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const log = await fetch(`${api}/admin/gr-server/logs/${id}`, requestOptions);
        const res = await log.json();
        return res;
    }

    // Integration

    async getIntegrations() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/integrations`, requestOptions);
        return res.json();
    }

    async getIntegrationByName(name) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/integrations/${name}`, requestOptions);
        return res.json();
    }

    async getIntegrationsByType(type) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/integrations/type/${type}`, requestOptions);
        return res.json();
    }

    async getIntegrationSetup() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/integrations/setup`, requestOptions);
        return res.json();
    }

    async getIntegrationById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/integrations/id/${id}`, requestOptions);
        return res.json();
    }

    async testIntegrationById(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const res = await fetch(`${api}/admin/integrations/${id}/test`, requestOptions);
        return await res.json();
    }

    async updateIntegration(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const inventory = await fetch(`${api}/admin/integrations`, requestOptions);
        const res = await inventory.json();
        return res;
    }

    // Integration Secret

    async createIntegrationSecret(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const res = await fetch(`${api}/admin/integration-secrets`, requestOptions);
        return await res.json();
    }

    async deleteIntegrationSecretById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const res = await fetch(`${api}/admin/integration-secrets/${id}`, requestOptions);
        return await res.json();
    }

    // Inventory

    async getInventories() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const inventory = await fetch(`${api}/admin/inventories`, requestOptions);
        const res = await inventory.json();
        return res;
    }

    async getInventoryById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const inventory = await fetch(`${api}/admin/inventories/${id}`, requestOptions);
        const res = await inventory.json();
        return res;
    }

    async createInventory(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const inventory = await fetch(`${api}/admin/inventories`, requestOptions);
        const res = await inventory.json();
        return res;
    }

    async restockInventory(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const res = await fetch(`${api}/admin/inventories/${id}/restock`, requestOptions);
        return await res.json();
    }

    async updateInventory(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const inventory = await fetch(`${api}/admin/inventories`, requestOptions);
        const res = await inventory.json();
        return res;
    }

    async deleteInventory(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, data, true);
        const inventory = await fetch(`${api}/admin/inventories`, requestOptions);
        const res = await inventory.json();
        return res;
    }

    // Login

    async login(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const login = await fetch(`${api}/admin/login`, requestOptions);
        const res = await login.json();
        return res;
    }

    // Media

    async getMedia() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const getMedia = await fetch(`${api}/admin/media`, requestOptions);
        const res = await getMedia.json();
        return res;
    }

    async getMediaById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const getMediaById = await fetch(`${api}/admin/media/${id}`, requestOptions);
        const res = await getMediaById.json();
        return res;
    }

    async changeMediaActivationStatus(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const changeMediaStatus = await fetch(`${api}/admin/media/activate`, requestOptions);
        const res = await changeMediaStatus.json();
        return res;
    }

    async postMediaAudio(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const postAudio = await fetch(`${api}/admin/media/audio`, requestOptions);
        const res = await postAudio.json();
        return res;
    }

    async postMediaVideo(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const postVideo = await fetch(`${api}/admin/media/video`, requestOptions);
        const res = await postVideo.json();
        return res;
    }

    async postMediaYoutube(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const postYoutube = await fetch(`${api}/admin/media/youtube`, requestOptions);
        const res = await postYoutube.json();
        return res;
    }

    async updateMedia(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const patchMedia = await fetch(`${api}/admin/media`, requestOptions);
        const res = await patchMedia.json();
        return res;
    }

    async downloadMedia() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const response = await fetch(`${api}/admin/media/download`, requestOptions);

        if (!response.ok) {
            throw new Error('Failed to download media');
        }

        const blob = await response.blob();
        const date = new Date().toISOString().slice(0, 10);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `media-${date}.tar.gz`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    async deleteMedia(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, data, true);
        const deleteMedia = await fetch(`${api}/admin/media`, requestOptions);
        const res = await deleteMedia.json();
        return res;
    }

    // Messages

    async createMessageNote(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const messageNote = await fetch(`${api}/admin/messages/notes`, requestOptions);
        const res = await messageNote.json();
        return res;
    }

    async getMessages(params = {}) {
        const query = new URLSearchParams(params).toString();
        const url = `${api}/admin/messages${query ? `?${query}` : ''}`;

        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const response = await fetch(url, requestOptions);
        const res = await response.json();
        return res;
    }

    async getMessageById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const account = await fetch(`${api}/admin/messages/${id}`, requestOptions);
        const res = await account.json();
        return res;
    }

    async updateMessage(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const patchWelcomeImage = await fetch(`${api}/admin/messages`, requestOptions);
        const res = await patchWelcomeImage.json();
        return res;
    }

    async deleteMessageNote(messageId, noteId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const deleteMessageNote = await fetch(`${api}/admin/messages/${messageId}/notes/${noteId}`, requestOptions);
        const res = await deleteMessageNote.json();
        return res;
    }

    // Metrics

    async getCustomersByDateRange(startDate = null, endDate = null) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        let params = '';
        if(startDate && endDate) {
            params = `?startDate=${startDate}&endDate=${endDate}`;
        }
        const customers = await fetch(`${api}/admin/metrics/customers${params}`, requestOptions);
        const res = await customers.json();
        return res;
    }

    async getMetricsDashboard(period = 'month') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const dashboard = await fetch(`${api}/admin/metrics/dashboard?period=${period}`, requestOptions);
        const res = await dashboard.json();
        return res;
    }

    async getTopProducts(startDate = null, endDate = null, limit = 10) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        let params = `?limit=${limit}`;
        if(startDate && endDate) {
            params += `&startDate=${startDate}&endDate=${endDate}`;
        }
        const products = await fetch(`${api}/admin/metrics/top-products${params}`, requestOptions);
        const res = await products.json();
        return res;
    }

    async getOrdersByDateRange(startDate = null, endDate = null) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        let params = '';
        if(startDate && endDate) {
            params = `?startDate=${startDate}&endDate=${endDate}`;
        }
        const orders = await fetch(`${api}/admin/metrics/orders${params}`, requestOptions);
        const res = await orders.json();
        return res;
    }

    // Notes

    async addNoteImage(noteId, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true, true);
        const noteImage = await fetch(`${api}/admin/notes/${noteId}/images`, requestOptions);
        const res = await noteImage.json();
        return res;
    }

    async updateNote(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const note = await fetch(`${api}/admin/notes/${id}`, requestOptions);
        const res = await note.json();
        return res;
    }

    async deleteNoteImage(noteId, imageId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const deleteMessageNote = await fetch(`${api}/admin/notes/${noteId}/images/${imageId}`, requestOptions);
        const res = await deleteMessageNote.json();
        return res;
    }

    // Orders

    async getOrdersByStatus(status = 'new') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const orders = await fetch(`${api}/admin/orders/status/${status}`, requestOptions);
        const res = await orders.json();
        return res;
    }

    async getOrders(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const orders = await fetch(`${api}/admin/orders${query}`, requestOptions);
        const res = await orders.json();
        return res;
    }

    async getPullSheet() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const orders = await fetch(`${api}/admin/orders/pull-sheet`, requestOptions);
        const res = await orders.json();
        return res;
    }

    async exportOrders(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const orders = await fetch(`${api}/admin/orders/export${query}`, requestOptions);
        const res = await orders.json();
        return res;
    }

    async exportUsers(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const users = await fetch(`${api}/admin/users/export${query}`, requestOptions);
        const res = await users.json();
        return res;
    }

    async exportProducts(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const products = await fetch(`${api}/admin/products/export${query}`, requestOptions);
        const res = await products.json();
        return res;
    }

    async exportCategories(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const categories = await fetch(`${api}/admin/categories/export${query}`, requestOptions);
        const res = await categories.json();
        return res;
    }

    async exportInventories(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const inventories = await fetch(`${api}/admin/inventories/export${query}`, requestOptions);
        const res = await inventories.json();
        return res;
    }

    async exportFulfillments(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const fulfillments = await fetch(`${api}/admin/fulfillments/export${query}`, requestOptions);
        const res = await fulfillments.json();
        return res;
    }

    async getOrderById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const order = await fetch(`${api}/admin/orders/${id}`, requestOptions);
        const res = await order.json();
        return res;
    }

    async createOrderNote(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const orderNote = await fetch(`${api}/admin/orders/notes`, requestOptions);
        const res = await orderNote.json();
        return res;
    }

    // TODO: Delete after order item upgrade
    async getLegacyOrders() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const legacyOrders = await fetch(`${api}/admin/orders/upgrade`, requestOptions);
        const res = await legacyOrders.json();
        return res;
    }

    async upgradeLegacyOrders(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const upgrade = await fetch(`${api}/admin/orders/upgrade`, requestOptions);
        const res = await upgrade.json();
        return res;
    }
    async getLegacyOrderFulfillments() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const legacyOrders = await fetch(`${api}/admin/orders/fulfillments/upgrade`, requestOptions);
        const res = await legacyOrders.json();
        return res;
    }

    async upgradeLegacyOrderFulfillments() {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, '', true);
        const upgrade = await fetch(`${api}/admin/orders/fulfillments/upgrade`, requestOptions);
        const res = await upgrade.json();
        return res;
    }



    async reshipDecision(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const decision = await fetch(`${api}/admin//orders/${id}/reship-status`, requestOptions);
        const res = await decision.json();
        return res;
    }

    async updateOrder(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const patchOrder = await fetch(`${api}/admin/orders`, requestOptions);
        const res = await patchOrder.json();
        return res;
    }

    async cancelOrder(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, '', true);
        const patchOrder = await fetch(`${api}/admin/orders/cancel/${id}`, requestOptions);
        const res = await patchOrder.json();
        return res;
    }

    async sendPaymentLink(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const patchOrder = await fetch(`${api}/admin/orders/payment-link`, requestOptions);
        const res = await patchOrder.json();
        return res;
    }

    async shipOrder(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const patchOrder = await fetch(`${api}/admin/orders/ship`, requestOptions);
        const res = await patchOrder.json();
        return res;
    }

    async deleteOrderNote(orderId, noteId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const deleteOrderNote = await fetch(`${api}/admin/orders/${orderId}/notes/${noteId}`, requestOptions);
        const res = await deleteOrderNote.json();
        return res;
    }

    // Pages

    async getPages(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const pages = await fetch(`${api}/admin/pages${query}`, requestOptions);
        const res = await pages.json();
        return res;
    }

    async getPageById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const pages = await fetch(`${api}/admin/pages/${id}`, requestOptions);
        const res = await pages.json();
        return res;
    }

    async getPagesByType(type) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const pagesByType = await fetch(`${api}/admin/pages/type/${type}`, requestOptions);
        const res = await pagesByType.json();
        return res;
    }

    async createPage(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const page = await fetch(`${api}/admin/pages`, requestOptions);
        const res = await page.json();
        return res;
    }

    async updatePage(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const page = await fetch(`${api}/admin/pages/${id}`, requestOptions);
        const res = await page.json();
        return res;
    }

    async deletePage(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const deleteProduct = await fetch(`${api}/admin/pages/${id}`, requestOptions);
        const res = await deleteProduct.json();
        return res;
    }

    // Page Types
    
    async getPageTypes(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const products = await fetch(`${api}/admin/page-types${query}`, requestOptions);
        const res = await products.json();
        return res;
    }

    // Products

    async getProducts(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const products = await fetch(`${api}/admin/products${query}`, requestOptions);
        const res = await products.json();
        return res;
    }

    async getProductsByType(type) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get);
        const products = await fetch(`${api}/products/type/${type}`, requestOptions);
        const res = await products.json();
        return res;
    }

    async getProductById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const product = await fetch(`${api}/admin/products/${id}`, requestOptions);
        const res = await product.json();
        return res;
    }

    async getProductInventory() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const inventory = await fetch(`${api}/admin/products`, requestOptions);
        const res = await inventory.json();
        return res;
    }

    async getProductsByCategoryId(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const products = await fetch(`${api}/admin/products/category/${id}`, requestOptions);
        const res = await products.json();
        return res;
    }

    async getProductTypes() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const productTypes = await fetch(`${api}/admin/product-types`, requestOptions);
        const res = await productTypes.json();
        return res;
    }

    async getProductProfiles() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get);
        const productProfiles = await fetch(`${api}/products/profiles/all`, requestOptions);
        const res = await productProfiles.json();
        return res;
    }

    async createProduct(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const product = await fetch(`${api}/admin/products`, requestOptions);
        const res = await product.json();
        return res;
    }

    async createProductProfile(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const productProfile = await fetch(`${api}/admin/products/profiles`, requestOptions);
        const res = await productProfile.json();
        return res;
    }

    async addProductImage(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true, true);
        const productImage = await fetch(`${api}/admin/products/images`, requestOptions);
        const res = await productImage.json();
        return res;
    }

    async updateProduct(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const updateProduct = await fetch(`${api}/admin/products`, requestOptions);
        const res = await updateProduct.json();
        return res;
    }

    async deleteProduct(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, data, true);
        const deleteProduct = await fetch(`${api}/admin/products`, requestOptions);
        const res = await deleteProduct.json();
        return res;
    }

    async deleteProductImage(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, data, true);
        const deleteProductImage = await fetch(`${api}/admin/products/product-image`, requestOptions);
        const res = await deleteProductImage.json();
        return res;
    }

    // Product Types

    async getAllProductTypes(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const result = await fetch(`${api}/admin/product-types${query}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async getProductTypeById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const result = await fetch(`${api}/admin/product-types/${id}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async createProductType(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const result = await fetch(`${api}/admin/product-types`, requestOptions);
        const res = await result.json();
        return res;
    }

    async updateProductType(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.put, data, true);
        const result = await fetch(`${api}/admin/product-types/${id}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async deleteProductType(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const result = await fetch(`${api}/admin/product-types/${id}`, requestOptions);
        const res = await result.json();
        return res;
    }

    // Product Type Fields

    async getAllProductTypeFields(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const result = await fetch(`${api}/admin/product-type-fields${query}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async getProductTypeFieldById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const result = await fetch(`${api}/admin/product-type-fields/${id}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async getProductTypeFieldsByProductType(productTypeId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const result = await fetch(`${api}/admin/product-type-fields/by-product-type/${productTypeId}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async createProductTypeField(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const result = await fetch(`${api}/admin/product-type-fields`, requestOptions);
        const res = await result.json();
        return res;
    }

    async updateProductTypeField(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.put, data, true);
        const result = await fetch(`${api}/admin/product-type-fields/${id}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async deleteProductTypeField(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const result = await fetch(`${api}/admin/product-type-fields/${id}`, requestOptions);
        const res = await result.json();
        return res;
    }

    async deleteProductTypeFieldsByProductType(productTypeId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const result = await fetch(`${api}/admin/product-type-fields/by-product-type/${productTypeId}`, requestOptions);
        const res = await result.json();
        return res;
    }

    // Raffles

    async getRaffles(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const raffles = await fetch(`${api}/admin/raffles${query}`, requestOptions);
        const res = await raffles.json();
        return res;
    }

    async getRaffleById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const raffle = await fetch(`${api}/admin/raffles/${id}`, requestOptions);
        const res = await raffle.json();
        return res;
    }

    async createRaffle(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const raffle = await fetch(`${api}/admin/raffles`, requestOptions);
        const res = await raffle.json();
        return res;
    }

    async updateRaffle(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const updateRaffle = await fetch(`${api}/admin/raffles`, requestOptions);
        const res = await updateRaffle.json();
        return res;
    }

    async deleteRaffle(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, data, true);
        const deleteProduct = await fetch(`${api}/admin/raffles`, requestOptions);
        const res = await deleteProduct.json();
        return res;
    }

    // Roles

    async getRoles() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const roles = await fetch(`${api}/admin/roles`, requestOptions);
        const res = await roles.json();
        return res;
    }

    // Sales

    async getSales() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const sales = await fetch(`${api}/admin/sales`, requestOptions);
        const res = await sales.json();
        return res;
    }

    async createSale(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const product = await fetch(`${api}/admin/sales`, requestOptions);
        const res = await product.json();
        return res;
    }

    async updateSale(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const updateSale = await fetch(`${api}/admin/sales`, requestOptions);
        const res = await updateSale.json();
        return res;
    }

    async changeSaleActivationStatus(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const updateSale = await fetch(`${api}/admin/sales/activation`, requestOptions);
        const res = await updateSale.json();
        return res;
    }

    // Sections

    async getSections(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const sections = await fetch(`${api}/admin/sections${query}`, requestOptions);
        const res = await sections.json();
        return res;
    }

    async getSectionById(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const section = await fetch(`${api}/admin/sections/${id}`, requestOptions);
        const res = await section.json();
        return res;
    }

    async createSection(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const section = await fetch(`${api}/admin/sections`, requestOptions);
        const res = await section.json();
        return res;
    }

    async addSectionImages(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const sectionImages = await fetch(`${api}/admin/sections/${id}/images`, requestOptions);
        const res = await sectionImages.json();
        return res;
    }

    async updateSection(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const section = await fetch(`${api}/admin/sections/${id}`, requestOptions);
        const res = await section.json();
        return res;
    }

    async deleteSection(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const section = await fetch(`${api}/admin/sections/${id}`, requestOptions);
        const res = await section.json();
        return res;
    }

    async deleteSectionImage(id, imageId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const sectionImage = await fetch(`${api}/admin/sections/${id}/images/${imageId}`, requestOptions);
        const res = await sectionImage.json();
        return res;
    }

    // Setup

    async setup() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get);
        const setup = await fetch(`${api}/setup`, requestOptions);
        const res = await setup.json();
        return res;
    }

    // Shipping Options

    async getShippingOptions(companyId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/shipping/options?companyId=${companyId}`, requestOptions);
        return await res.json();
    }

    async createShippingOption(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const res = await fetch(`${api}/admin/shipping/options`, requestOptions);
        return await res.json();
    }

    async updateShippingOption(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const res = await fetch(`${api}/admin/shipping/options/${id}`, requestOptions);
        return await res.json();
    }

    async deleteShippingOption(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const res = await fetch(`${api}/admin/shipping/options/${id}`, requestOptions);
        return await res.json();
    }

    // Shipping Providers

    async getShippingProviders() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/shipping/providers`, requestOptions);
        return await res.json();
    }

    async createShippingProvider(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const res = await fetch(`${api}/admin/shipping/providers`, requestOptions);
        return await res.json();
    }

    async updateShippingProvider(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const res = await fetch(`${api}/admin/shipping/providers/${id}`, requestOptions);
        return await res.json();
    }

    async deleteShippingProvider(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const res = await fetch(`${api}/admin/shipping/providers/${id}`, requestOptions);
        return await res.json();
    }

    // Shipping Types

    async getShippingTypes() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const res = await fetch(`${api}/admin/shipping/types`, requestOptions);
        return await res.json();
    }

    async createShippingType(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const res = await fetch(`${api}/admin/shipping/types`, requestOptions);
        return await res.json();
    }

    async updateShippingType(id, data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.patch, data, true);
        const res = await fetch(`${api}/admin/shipping/types/${id}`, requestOptions);
        return await res.json();
    }

    async deleteShippingType(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const res = await fetch(`${api}/admin/shipping/types/${id}`, requestOptions);
        return await res.json();
    }

    // Themes

    async getThemes(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const themes = await fetch(`${api}/admin/themes${query}`, requestOptions);
        const res = await themes.json();
        return res;
    }

    async createThemeImage(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const themeImage = await fetch(`${api}/admin/themes/images`, requestOptions);
        const res = await themeImage.json();
        return res;
    }

    async deleteTheme(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const image = await fetch(`${api}/admin/themes/${id}`, requestOptions);
        const res = await image.json();
        return res;
    }

    async deleteThemeImage(id) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const image = await fetch(`${api}/admin/themes/images/${id}`, requestOptions);
        const res = await image.json();
        return res;
    }

    // Users

    async createUserNote(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true, true);
        const userNote = await fetch(`${api}/admin/users/notes`, requestOptions);
        const res = await userNote.json();
        return res;
    }

    async getUsers(query = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const users = await fetch(`${api}/admin/users${query}`, requestOptions);
        const res = await users.json();
        return res;
    }

    async getUsersByRoleId(roleId = '') {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const users = await fetch(`${api}/admin/users/role/${roleId}`, requestOptions);
        const res = await users.json();
        return res;
    }

    async adminPasswordReset(data) {
        const requestOptions = this.fetchOptions(this.fetchMethods.post, data, true);
        const passwordReset = await fetch(`${api}/admin/users/password-reset`, requestOptions);
        const res = await passwordReset.json();
        return res;
    }

    async deleteUserNote(userId, noteId) {
        const requestOptions = this.fetchOptions(this.fetchMethods.delete, '', true);
        const deleteUserNote = await fetch(`${api}/admin/users/${userId}/notes/${noteId}`, requestOptions);
        const res = await deleteUserNote.json();
        return res;
    }

    // Views

    async getViews() {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        const views = await fetch(`${api}/admin/metrics/views`, requestOptions);
        const res = await views.json();
        return res;
    }

    async getViewsByDateRange(startDate = null, endDate = null) {
        const requestOptions = this.fetchOptions(this.fetchMethods.get, '', true);
        let params = '';
        if(startDate && endDate) {
            params = `?startDate=${startDate}&endDate=${endDate}`;
        }
        const views = await fetch(`${api}/admin/metrics/views/date${params}`, requestOptions);
        const res = await views.json();
        return res;
    }
}